<template>
    <div class="w-share2">
        <el-popover trigger="hover" placement="right" popper-class="u-share2-pop">
            <div class="u-share2-content">
                <div class="u-share2-content-main">
                    <div
                        v-for="shareItem in shareList"
                        class="u-share2-item"
                        :key="shareItem.key"
                        @click="share(shareItem.key)"
                        title="分享"
                    >
                        <img class="u-share-icon" svg-inline :src="shareItem.img" :alt="shareItem.name">
                        <div class="u-share2-name">{{ shareItem.name }}</div>
                    </div>
                    <!-- <p class="tip">将文章链接贴</p> -->
                </div>
                <div class="u-share2-wechat">
                    <qrcode-vue
                        class="u-pic"
                        :value="url.href"
                        :size="75"
                        level="H"
                    ></qrcode-vue>
                    <span>微信扫一扫分享</span>
                </div>
            </div>

            <div slot="reference">
                <el-tooltip class="item" effect="dark" content="分享" placement="top">
                    <div v-if="simple">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.6 481.6" v-bind:class="'u-icon u-simple-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M381.6 309.4c-27.7 0-52.4 13.2-68.2 33.6l-132.3-73.9c3.1-8.9 4.8-18.5 4.8-28.4 0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7 20.5 40.5 33.8 68.3 33.8 47.4 0 86.1-38.6 86.1-86.1S429 0 381.5 0s-86.1 38.6-86.1 86.1c0 10 1.7 19.6 4.9 28.5l-132.1 73.8c-15.7-20.6-40.5-33.8-68.3-33.8-47.4 0-86.1 38.6-86.1 86.1s38.7 86.1 86.2 86.1c27.8 0 52.6-13.3 68.4-33.9l132.2 73.9c-3.2 9-5 18.7-5 28.7 0 47.4 38.6 86.1 86.1 86.1s86.1-38.6 86.1-86.1-38.7-86.1-86.2-86.1zm0-282.3c32.6 0 59.1 26.5 59.1 59.1s-26.5 59.1-59.1 59.1-59.1-26.5-59.1-59.1 26.6-59.1 59.1-59.1zM100 299.8c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.6 59.1-59.1 59.1zm281.6 154.7c-32.6 0-59.1-26.5-59.1-59.1s26.5-59.1 59.1-59.1 59.1 26.5 59.1 59.1-26.5 59.1-59.1 59.1z"/></svg>
                        <!-- <i class="el-icon-position"></i> -->
                        <span class="u-text">分享</span>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 768 768" v-else="" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="st0" d="M540.2 8.1c5.6 4.2 11.8 7.8 16.6 12.7 65.8 68 131.3 136.1 196.9 204.3 11.4 11.8 11.5 24.7.3 36.3-66.6 69.3-133.2 138.4-199.8 207.6-6.9 7.2-14.7 11.5-24.9 9-11.5-2.8-18.1-12-18.1-25.3-.1-30.1 0-60.3 0-90.4V354c-19.9 0-39.3-1.4-58.4.3-66.1 5.6-122.3 32.7-167.9 81.1-16.9 17.9-30.5 38.2-41.9 60.1-8.4 16.1-27.7 19.3-39 6.4-3.2-3.6-6-9-6-13.7-.6-40.4-2.2-80.9 8.3-120.5 28-105.7 93.5-177.7 195.4-216.5 32.6-12.4 66.7-17.2 101.5-17.7 2 0 3.9-.1 5.9-.2.4 0 .8-.4 2.1-1v-7.5c0-28.2.4-56.4-.2-84.5-.3-14.5 3.5-25.9 17.5-32.1 3.9-.1 7.8-.1 11.7-.1z" fill="#2296f2"/><path class="st1" d="M9.3 212.5c.9-2.2 2-4.3 2.6-6.5 10.5-42.1 46.4-71.5 89.8-72.4 31.6-.7 63.2-.4 94.8-.1 19 .1 32.3 13.7 32.2 31.9-.1 17.9-13.9 30.9-33 31-29.9.1-59.8 0-89.7 0-20.8 0-33.7 12.7-33.7 33.2v435.3c0 20.7 12.7 33.3 33.6 33.3h560.3c20.7 0 33.2-12.7 33.3-33.6.1-81.9 0-163.7 0-245.6 0-19.8 12.7-33.9 30.7-34.4 17.7-.4 31.9 13.2 32.2 31.1.2 16.4.1 32.8.1 49.3v198.5c0 56.9-40.8 97.6-97.9 97.6H108.7c-50.4 0-85.3-27.3-97.7-76.4-.3-1.1-1-2-1.6-3-.1-156.4-.1-312.8-.1-469.2z" fill="#617d8b"/></svg>
                </el-tooltip>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { __imgPath } from "@jx3box/jx3box-common/data/jx3box.json";
import QrcodeVue from "qrcode.vue";
import _ from "lodash";
export default {
    name: "Share2",
    // meta: { title, summary, banner, desc } 
    props: ["postType", "postId", "meta", "simple"],
    data: function () {
        return {
            apis: {
                qzone: 'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?',
                qq: 'http://connect.qq.com/widget/shareqq/index.html?',
                wechat: '',
                weibo: 'https://service.weibo.com/share/share.php?',
                tieba: 'http://tieba.baidu.com/f/commit/share/openShareApi?'
            },
            shareList: [
                {
                    name: '微博',
                    key: 'weibo',
                    img: require('../../assets/img/widget/weibo.svg'),
                },
                {
                    name: 'QQ',
                    key: 'qq',
                    img: require('../../assets/img/widget/qq.svg'),
                },
                {
                    name: 'QQ空间',
                    key: 'qzone',
                    img: require('../../assets/img/widget/qzone.svg'),
                },
                {
                    name: '贴吧',
                    key: 'tieba',
                    img: require('../../assets/img/widget/tieba.svg'),
                },
                /* {
                    name: '微信',
                    key: 'wechat',
                    img: require('../../assets/img/widget/weixin.svg'),
                }, */
            ]
        };
    },
    computed: {
        ready() {
            return !!(this.postType && this.postId);
        },
        url() {
            return document.location;
        },
        title() {
            return this.meta?.title || document.title;
        },
        pic: function() {
            return this.meta?.banner ||  __imgPath + `image/common/logo.png`;
        },
        urls: function() {
            return  {
                qzone: this.shareToQzone,
                weibo: this.shareToWeibo,
                tieba: this.shareToTieba,
                qq: this.shareToQQ,
            }
        },
    },
    methods: {
        init: function () {
        },
        shareToWeibo: function (){
            return this.apis['weibo']
                + `url=${this.url}`
                + `&title=${this.title}`
                + `&pic=${this.pic}`;
        },
        shareToQzone: function (){
            return this.apis['qzone']
                + `url=${this.url}`
                + `&title=${this.title}`
                + '&sharesource=qzone'
                + `&summary=${this.meta?.summary || ''}`
                + `&desc=${this.meta?.desc || ''}`
                + `&pics=${this.pic}`;
        },
        shareToQQ: function (){
            return this.apis['qq']
                + `url=${this.url}`
                + `&title=${this.title}`
                + `&pics=${this.pic}`;
        },
        shareToTieba: function (){
            return this.apis['tieba']
                + `url=${this.url}`
                + `&title=${this.title}`
                + `&summary=${this.meta?.summary || ''}`
                + `&desc=${this.meta?.desc || ''}`
                + `&pic=${this.pic}`;
        },
        share: function (val){
            window.open(this.urls[val](), "_blank")
        }
    },
    mounted: function () {
        this.init();
    },
    components: {
        QrcodeVue
    }
};
</script>

<style lang="less">
@import "../../assets/css/share2.less";
</style>
